export default (state = [], action) => {
	switch (action.type) {
		case "SET_WORK_TYPES":
			return [...action.work_types];
		default:
			return state;
	}
};
